var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stars"},[_vm._l((5),function(n){return [(n <= Math.floor(_vm.average))?_c('b-icon',{attrs:{"icon":"star","size":_vm.size}}):(n === Math.ceil(_vm.average) && _vm.average < n)?_c('b-icon',{attrs:{"icon":"star-half","size":_vm.size}}):_c('b-icon',{attrs:{"icon":"star-outline","size":_vm.size}})]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b59241c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/taskflex/students/components/profile/ratings/Stars.vue
// module id = zY7B
// module chunks = 1